import styles from "./index.module.css";
import { animated } from "@react-spring/web";
const Subject = ({ movieListStyle }) => {
  return (
    <animated.div
      className={styles.ctn}
      style={{ opacity: movieListStyle.opacity }}
    >
      <div className={styles.main}>MAKE IT REAL</div>
      <div className={styles.sec}>#Tell Better Stories</div>
    </animated.div>
  );
};

export default Subject;
